import {
  EnvVariableKey,
  EnvVariables,
  fetchEnvVars,
  isValid,
  validateEnvVars,
} from '@/services/EnvService'
import { defineStore } from 'pinia'
import { OpenAPI } from '@itemis-solutions/platform-client-sdk'
import { useAsyncState, whenever } from '@vueuse/core'
import { computed } from 'vue'

export const useEnvStore = defineStore('env', () => {
  const {
    state: unparsedEnvVariables,
    execute: fetchEnv,
    isReady,
  } = useAsyncState(fetchEnvVars, null, {
    immediate: false,
  })

  const validations = computed(() => validateEnvVars(unparsedEnvVariables.value))

  const variables = computed(() => {
    return validations.value.filter(isValid).reduce(
      (variables, validation) => {
        variables[validation.envKey] = validation.envValue
        return variables
      },
      {} as Record<EnvVariableKey, EnvVariables[EnvVariableKey]>,
    ) as EnvVariables
  })

  whenever(isReady, () => {
    OpenAPI.BASE = variables.value.ANALYZE_PLATFORM_URL
  })

  return {
    fetchEnv,
    variables,
    validations,
  }
})
